import BetBuilderPlaceMarketModel from './betbuilder-place-market.model';
/**
 * Bet builder item in place request
 */
export default class BetBuilderPlaceModel {
  constructor({ betResponse, price, betBuilderItem, swishModel = false, match }) {
    /**
     * Match id
     * @type {number}
     */
    this.mid = betBuilderItem.matchId;
    /**
     * Match sportcast fixture id
     * @type {number}
     */
    this.scfi = swishModel ? null : betResponse.FixtureId;
    /**
     * Sport cast sport id
     * @type {number}
     */
    this.scsid = swishModel ? null : betResponse.Sport;
    /**
     * Bet builder match identifier
     * @type {string}
     */
    this.mi = betResponse.Identifier;
    /**
     * Betbuilder odd
     * @type {number}
     */
    this.odd = price;
    /**
     * Bet builder probability
     * @type {number}
     */
    this.probability = swishModel ? null : betResponse.PriceDetails.Decimal;
    /**
     * Bet builder sportcast unique id
     * @type {string}
     */
    this.bsuid = swishModel ? betResponse.Identifier : betResponse.BetSlipUid;
    /**
     * Bet builder description
     * @type {string}
     */
    this.desc = betResponse.Description.join(', ');
    if (swishModel && match) {
      /**
       * @type {{t:string,h:number,a:number,m:number,sm:number}}
       */
      this.sfm = {
        t: (match.swTournamentName || '').toLowerCase(),
        h: match.swHomeTeamID,
        a: match.swAwayTeamID,
        m: match.swMatchId,
        sm: match.swSwishMatchID
      };
    }
    /**
     * Bet builder markets for item
     * @type {BetBuilderPlaceMarketModel[]}
     */
    this.ld = betResponse.LegDetails.map(m => new BetBuilderPlaceMarketModel(m, betBuilderItem, swishModel));
  }
}
